module.exports = __webpack_public_path__ + "img/ticketz_maestrobeatz.0326a64.png";